export default __webpack_public_path__ + "e5fa6ed5d237383510eb21d1c9494ae9.webp";